const WhatsappPhones = () => import('./WhatsappPhones.vue')

export default [
  {
    name: 'whatsapp-phones',
    path: 'whatsapp',
    component: WhatsappPhones,
    meta: {
      access: ['org.communication.whatsapp.view']
    }
  }
]
